function negotiateStep(input, options) {
	if (options.type === 'number')
		input.step = 'any';
}

module.exports = negotiateStep;